<template>
  <div>
    <div>
      <vxe-grid ref="xGrid" @edit-actived="mainEditActived" :cell-class-name="cellClassName" class="mytable-style"
        v-bind="gridOptions" :loading="loading" @edit-disabled="editDisabledEvent" show-header-overflow
        @checkbox-change="checkboxChangeEventMFC" @checkbox-all="checkboxChangeEventMFC"
        :cell-style="{ padding: '3px', 'font-size': '12px', 'line-height': '16px ' }">

        <template #toolbar>
          <div style="display: flex;gap: 10px; margin: 10px 0; ">
            <div>
              <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="addNewData('searchAddRedLine2')"
                :disabled="getAddPriv()">{{
                  $t("message.button.add") }}
              </el-button>
              <el-button class="btn btn2" icon="el-icon-delete" @click="removeRow" :disabled='getRemovePriv()'>{{
                $t("message.button.delete") }}
              </el-button>
              <el-button class="btn btn3" icon="el-icon-help" @click="restoreRow" :disabled='getRemovePriv()'>{{
                $t("message.button.Undo") }}
              </el-button>

            </div>
            <div style="margin-left: auto;">
              <el-button class="btn btn7" icon="el-icon-document-checked" @click="submitData"
                :disabled="getAddPriv()">{{
                  $t("message.button.save") }}
              </el-button>
              <el-button class="btn btn8" icon="el-icon-circle-close" @click="redLineManufactCloseSave"
                :disabled="getAddPriv()">{{
                  $t("message.button.cancel") }}
              </el-button>
            </div>
          </div>
        </template>

        <template #bottom>
          <Bottom-Tips :data="{ selectRecords: selectRecords.length, totalRecords: totalRecordsMFC }" />
        </template>
      </vxe-grid>
    </div>
    <el-dialog v-dialogDrag v-if="searchAddRedLine2" class="searchAddRedLineList" :title="$t('message.title.add')"
      :visible.sync="searchAddRedLine2" :close-on-click-modal="false" :close-on-press-escape="false">
      <searchManufacturerReadLine @listDbClick="addRedLineList2">
        <div>
          <el-button size="small" type="primary" icon="el-icon-edit-outline" @click="creatNew = true">{{
            $t("message.button.create") }}</el-button>
        </div>
      </searchManufacturerReadLine>
    </el-dialog>

    <!-- <el-dialog v-dialogDrag v-if="getAlt" :title="BOMTitle" :visible.sync="getAlt" width="60%" @close="closeBOMList">
      <Alternative :majorInfo="majorInfo" @setAlteData="setAlteData" />
    </el-dialog> -->

    <el-dialog v-dialogDrag v-if="searchAddRedLine2" class="searchAddRedLineList" :title="$t('message.title.add')"
      :visible.sync="searchAddRedLine2" :close-on-click-modal="false" :close-on-press-escape="false">
      <searchManufacturerReadLine @listDbClick="addRedLineList2">
        <div>
          <el-button size="small" type="primary" icon="el-icon-edit-outline" @click="creatNew = true">{{
            $t("message.button.create") }}</el-button>
        </div>
      </searchManufacturerReadLine>
    </el-dialog>

    <el-dialog v-dialogDrag v-if="creatNew" class="searchAddBomList" :title="$t('message.title.add')"
      :visible.sync="creatNew" :close-on-click-modal="!creatNew">
      <Create v-if="searchAddRedLine2" :saveUrl="saveTableUrl2" :baseClass="baseClass_2" @addToList="creatNewModel"
        @closeCreateNew="closeCreateNew"></Create>

    </el-dialog>
  </div>

</template>
<script>
import { getNewRedLineTableContentData, getNewTableTitleData, gridOptions, setListEntry } from './affectItemConfig';
import { mapState, mapMutations } from 'vuex';
import searchManufacturerReadLine from "@/components/searchManufacturers.vue";
import Create from "@/components/common/Create.vue";
import axios from 'axios';

export default {
  data() {
    return {
      selectRecords: [],
      loading: false,
      totalRecordsMFC: "",
      searchAddRedLine2: false,
      creatNew: false,

      baseClass_2: "106",
      saveTableUrl2: "/pmdm/manufacturerPart/saveManufacturerPartP1P2P3",

      removeBtnPriv: false,

      addTableListPriv: false,
      gridOptions: {
        ...gridOptions, editConfig: {
          trigger: "dblclick",
          mode: "row",
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
      },

    }
  },
  components: {
    searchManufacturerReadLine,
    Create
  },
  props: {
    itemInfo: Object,
    changePrivs: Object
  },
  created() {
    this.loadUserPriv()
    this.getData();

  },
  computed: {

    ...mapState({
      pageChanged: (state) => state.pageChanged,
      activeName: (state) => state.activedTabInHome,
      objId: (state) => state.objectId,
      change_info: (state) => state.change_info,
      changeObjId: (state) => {
        const { id: changeId, classId: changeClassId, subClassId: changeSubClassId } = state.objectId
        return {
          changeId, changeClassId, changeSubClassId
        }
      }
    }),

  },
  methods: {

    ...mapMutations([
      'setPageChanged',
      'setPageRefresh',
      'replaceShowingTabsInHome',
      'setActivedTabInHome'
    ]),

    getAddPriv() {
      const { add = false } = this.changePrivs;
      return !add || !this.addTableListPriv
    },
    getRemovePriv() {
      const { add = false } = this.changePrivs;
      return !add || !this.removeBtnPriv
    },
    closeCreateNew() {
      this.creatNew = false;
    },
    activeRowMethod({ row, rowIndex }) {
      //console.log(this.childsTable);
      //console.log(row);
      if (row.disable) {
        return false;
      }
      return true;
    },
    creatNewModel(e) {

      this.addList(e);
      this.creatNew = false;
      this.searchAddBom = false;
    },

    addRedLineList2(row) {
      //添加
      if (row) {

        let insertBom = row.map((i) => {
          return {
            manufacturerPartId: i.id,
            manufacturerId: i.manufacturerId,
            itemId: this.itemInfo.id,
          };
        });
        var updateBomData = {
          //post更改的值
          tableId: this.Global.redLineManufacturerTableId,
          changeObjId: { ...this.objId },
          itemObjId: {
            id: this.itemInfo.id,
            classId: this.itemInfo.classId,
            subClassId: this.itemInfo.subClassId,
            version: this.itemInfo.version,
          },
          insertManufacturer: insertBom,
        };


        axios
          .post("/pmdm/items/saveTable", updateBomData)
          .then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: "success",
              });
              this.getData();
              // this.searchAddRedLine2 = false;
            }
          })
          .catch(function (error) {

          });
      }
    },
    editDisabledEvent({ row, column }) {
      alert(this.$t("message.error.noEdit"));
    },
    mainEditActived({ row, column }) {
      this.setPageChanged({ name: this.componentname, isChanged: true });
      this.getListEntry({ column, row })
    },
    async getData() {
      var obj_get2 = {
        //获取change
        ...this.itemInfo,
        tableId: this.Global.redLineManufacturerTableId,
      };

      const { data } = await this.$http.get(`/pmdm/items/loadTable${this.params(obj_get2)}`);

      const { columnInfo, rows, seekId, saveColumns = [] } = data.object.table
      const { listIds, listTypes, uiTypes, listEntries } = columnInfo;

      this.gridOptions.columns = getNewTableTitleData(columnInfo);

      this.cols2 = columnInfo.ids;
      this.gridOptions.data = getNewRedLineTableContentData(rows, columnInfo);

    },

    addNewData(dialogName) {
      if (this.pageChanged) {
        this.saveConfirm();
        return
      }
      this[dialogName] = true
    },


    loadUserPriv(row) {
      const isSuperAdmin = this.$store.state.isSuperAdmin;
      const privList = this.getUserContextPriv()
        .filter((i) => i.classId == this.objId.subClassId)
        .map((j) => j.type);
      this.addTableListPriv = isSuperAdmin || privList.includes(3);
      this.removeBtnPriv = isSuperAdmin || privList.includes(4);
    },
    checkboxChangeEventMFC({ records }) {
      const $grid = this.$refs.xGrid;
      this.selectRecords = records;
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      //console.log(columnIndex);
      if (row.redText) {
        for (var i = 0; i < row.redText.length; i++) {
          if (columnIndex == row.redText[i]) {
            return "col-red-text";
          }
        }
      } else if (row.redLine) {
        for (var i = 0; i < row.redLine.length; i++) {
          if (columnIndex == row.redLine[i]) {
            return "col-red";
          }
        }
      } else {
        return "";
      }
    },

    redLineManufactCloseSave() {
      this.$refs.xGrid.revertData(); //清除所有保存，删除，添加记录
    },

    removeRow() {
      if (this.pageChanged) {
        this.saveConfirm();
        return
      }
      var change_info = this.change_info;
      var removeRow = this.$refs.xGrid.getCheckboxRecords();
      //console.log(removeRow);
      var del_table = [];

      if (removeRow.length == 0) {
        return false;
      } else {
        console.log(removeRow);
        this.$confirm(this.$t("message.confirm.deleteData"))
          .then((_) => {
            for (var i = 0; i < removeRow.length; i++) {
              if (removeRow[i].disable) {
                this.$message.error(this.$t("message.error.deleteData"));
                return false;
              } else {
                var obj = {};
                obj.id = removeRow[i].rowId;
                obj.manufacturerPartId = removeRow[i].itemId;
                obj.redlineType = removeRow[i].redlineType;
                obj.parentRowId = removeRow[i].parentRowId;
                del_table.push(obj);
              }
            }
            var delBomData = {
              tableId: this.Global.redLineManufacturerTableId,
              changeObjId: {
                ...this.objId,
              },
              itemObjId: {
                id: this.itemInfo.id,
                classId: this.itemInfo.classId,
                subClassId: this.itemInfo.subClassId,
                version: this.itemInfo.version,
              },
              deleteManufacturer: del_table,
            };
            // console.log(delBomData);
            axios
              .post("/pmdm/items/deleteTable", delBomData)
              .then(res => {
                if (res.data.code == 200) {
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.getData();
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          })
          .catch((_) => { });
      }
    },
    restoreRow() {
      var removeRow = this.$refs.xGrid.getCheckboxRecords();
      //console.log(removeRow);
      var del_table = [];

      if (!removeRow.length) {
        return false;
      }

      this.$confirm(this.$t("message.confirm.unDoData"))
        .then((_) => {
          for (var i = 0; i < removeRow.length; i++) {
            if (!removeRow[i].redlineType) {
              this.$message.error(this.$t("message.error.unDoData"));
              return false;
            } else {
              var obj = {};
              obj.id = removeRow[i].rowId;
              obj.manufacturerPartId = removeRow[i].itemId;
              obj.parentRowId = removeRow[i].parentRowId;
              obj.redlineType = removeRow[i].redlineType;
              del_table.push(obj);
            }
          }
          var delBomData = {
            tableId: this.Global.redLineManufacturerTableId,
            changeObjId: {
              ...this.objId,
            },
            itemObjId: {
              id: this.itemInfo.id,
              classId: this.itemInfo.classId,
              subClassId: this.itemInfo.subClassId,
              version: this.itemInfo.version,
            },
            deleteManufacturer: del_table,
          };
          // console.log(delBomData);
          axios
            .post("/pmdm/items/undoTable", delBomData)
            .then(res => {
              if (res.data.code == 200) {
                this.$message({
                  message: res.data.message,
                  type: "success",
                });
                this.getData()
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch((_) => { });

    },

    submitData() {
      var xGrid_ = this.$refs.xGrid;
      let updateRecords = this.$refs.xGrid.getUpdateRecords(); //获取修改的行
      var updateBom = [];
      console.log(updateRecords);
      if (updateRecords.length !== 0) {
        //判断行内那些值有改动
        for (let i = 0; i < updateRecords.length; i++) {
          var num = xGrid_.getRowIndex(updateRecords[i]);
          var cols_length = this.cols2;
          for (let j = 0; j < cols_length.length; j++) {
            var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], "" + j);
            if (updateNewData) {

              for (let k = 0; k < this.gridOptions.columns.length; k++) {
                var obj = {};
                obj.redlineType = updateRecords[i].redlineType;
                if (cols_length[j] == this.gridOptions.columns[k].attid) {
                  var quantity = cols_length[j];
                  obj.id = updateRecords[i].rowId;
                  if (this.gridOptions.columns[k].editRender.props) {
                    //处理多选和单选
                    if (this.gridOptions.columns[k].editRender.props.multiple) {
                      obj[quantity] = updateRecords[i][j].join(";");
                    } else if (
                      this.gridOptions.columns[k].editRender.props.type ==
                      "datetime"
                    ) {
                      // obj[quantity] = updateRecords[i][j].format("yyyy-MM-ddThh:mm:ss");
                      obj[quantity] = this.format(
                        updateRecords[i][j],
                        "yyyy-MM-ddThh:mm:ss"
                      );
                      console.log(obj[quantity]);
                    } else {
                      obj[quantity] = updateRecords[i][j] ?? "";
                    }
                  } else {
                    obj[quantity] = updateRecords[i][j] ?? "";
                  }
                  updateBom.push(obj);
                }
              }
            }
          }
        }
        var change_info = this.change_info;
        var updateBomData = {
          //post更改的值
          tableId: this.Global.redLineManufacturerTableId,
          changeObjId: {
            ...this.objId,
          },
          itemObjId: {
            id: this.itemInfo.id,
            classId: this.itemInfo.classId,
            subClassId: this.itemInfo.subClassId,
            version: this.itemInfo.version,
          },
          updateManufacturer: this.arrayFilter(updateBom),
        };

        console.log(updateBomData);
        axios
          .post("/pmdm/items/updateTable", updateBomData)
          .then(res => {
            console.log(res);
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: "success",
              });
              // xGrid_.revertData();
              this.getData();
              this.setPageChanged({ name: this.componentname, isChanged: false })
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.$message({
          message: this.$t("message.error.noChange"),
          type: "warning",
        });
        // alert(this.$t('message.error.save'))
      }
    },
  }
}
</script>
<style lang="scss" scoped></style>